import { createContext, useContext } from 'react';

export enum CURRENT_AVAILABLE_GROUPS {
  Admin = 'Admin',
  CustomerSuccess = 'CustomerSuccess',
  CustomerAdmin = 'CustomerAdmin',
  CustomerReadonly = 'CustomerReadonly',
  CustomerEditor = 'CustomerEditor',
  CustomerCallCenterRep = 'CustomerCallCenterRep',
}

export interface UserData {
  name?: string;
  email?: string;
  givenName?: string;
  familyName?: string;
  sub?: string;
}

interface ContextValues {
  groups: CURRENT_AVAILABLE_GROUPS[];
  isInternal: boolean;
  user: UserData;
}

export const AuthContext = createContext<ContextValues>({
  groups: [],
  isInternal: false,
  user: {},
});

export const useAuthContext = (): ContextValues => useContext(AuthContext);
export const useHasAuthGroup = (group: CURRENT_AVAILABLE_GROUPS): boolean => {
  const { groups } = useContext(AuthContext);
  return groups.includes(group);
};
